import {
  LocationGeoType,
  BrandSafetyType,
  AdgroupFormData,
  CampaignFormData,
  AreaItem,
  LocationInfo,
  AreaItemOrigin,
  AreaMap,
  CloverAreaIds,
  TtpAreaIds,
  BrandSafetyPartnerType,
} from '@tt4b/ttam-enums';

export * from './genInputId';
const _cache = {};

export function getSelectedItemLabel({ areaMap, locationId }) {
  // 已选location展示：当前选择的item + country的下一层级
  const seletedItemLabel = [areaMap[locationId].translation];
  if (areaMap[locationId].level > LocationGeoType.PROVINCE) {
    let { parentId } = areaMap[locationId];
    let parentItem = areaMap[parentId];

    // TODO: 待修复
    // 向上查找到province的名称
    // 如果当前location的parent是province则不需要继续向上查找
    // 如果当前location的parent是province以上层级，如果向上查找也找不到，会出现parentId=0，所以也不继续向上查找（DMA的场景）
    while (parentItem?.level && parentItem.level !== LocationGeoType.PROVINCE) {
      parentId = parentItem?.parentId;
      parentItem = areaMap[parentId];
    }

    // areaMap[locationId].provinceId = parentItem.id;
    if (parentItem) {
      _cache[locationId] = {
        provinceId: parentItem.id,
        translation: parentItem?.translation,
      };
      seletedItemLabel.push(parentItem.translation);
    }
  }
  return seletedItemLabel;
}
export function transformSelectedIds(options: { ids: number[]; areaMap: AreaMap }) {
  const { ids, areaMap } = options;
  if (!areaMap) {
    console.error('areaMap is not exist');
    return;
  }
  const list = {};
  const names = [];
  ids.forEach(item => {
    let id = item;
    if (areaMap[id]?.level === LocationGeoType.ZIP_CODE) {
      id = areaMap[id]?.info?.geo?.parent_id;
    }

    const code = areaMap[id]?.countryCode || areaMap[id]?.info?.geo?.country_code;

    if (code) {
      if (!list[code]) {
        let countryId = id;
        let parentId = areaMap[countryId]?.parentId;
        while (parentId) {
          countryId = parentId;
          parentId = areaMap[parentId]?.parentId;
        }
        const country = areaMap[countryId];
        if (country) {
          list[code] = {
            name: country?.translation,
            id: country?.id,
            children: [],
          };
        }
      }
      const seletedItem = list[code];
      if (seletedItem) {
        let seletedItemLabel = [areaMap[item]?.translation];
        names.push(...seletedItemLabel);
        if (_cache[item]?.provinceId) {
          seletedItemLabel.push(_cache[item]?.translation);
        } else {
          // 已选location展示：当前选择的item + country的下一层级
          seletedItemLabel = getSelectedItemLabel({
            areaMap,
            locationId: item,
          });
        }
        seletedItem.children.push({
          name: seletedItemLabel.join(', '),
          id: item,
        });
      }
    }
  });

  return {
    selectedList: list,
    names,
  };
}

export function generateLocationTargetingAdContext(opt: {
  adgroupData: AdgroupFormData;
  campaignData: CampaignFormData;
}) {
  const { adgroupData, campaignData } = opt;
  const { objectiveType } = campaignData;
  const {
    inventoryFlow,
    platform,
    brandSafety,
    brandSafetyPartner,
    classify,
    externalType,
    promotionFlowType,
    promotionTargetType,
  } = adgroupData;

  return {
    classify,
    platform,
    inventoryFlow,
    objectiveType,
    brandSafety: brandSafety === BrandSafetyType.FLAGSHIP ? brandSafetyPartner && brandSafety : brandSafety,
    brandSafetyPartner,
    promotionFlowType,
    externalType,
    rfCampaignType: 0,
    promotionTargetType,
    industryTypes: campaignData.industryTypes,
  };
}

export function formatLocationItem(opt: {
  tags: LocationInfo[];
  associateTagsMap?: any;
  visible?: boolean;
  isNotNeedFormatAssociateTags?: boolean;
}) {
  const { tags, visible = false, associateTagsMap, isNotNeedFormatAssociateTags } = opt;
  const formatResult: AreaItem[] = [];
  const formatResultMap: Record<number, AreaItem> = {};

  function genFormatItem(item) {
    const filterLabelList = [item.name];

    const formatItem: AreaItem = {
      id: item?.geo?.id,
      name: item.name,
      info: item,
      level: item?.geo?.type,
      translation: item?.name,
      type: item?.geo?.description,
      status: item?.status_info?.status,
      visible,
      filterable: true,
      filterLabel: filterLabelList.join(', '),
      origin: AreaItemOrigin.SEARCH,
      parentId: item?.geo?.parent_id,
      countryCode: item?.geo?.country_code || item?.info?.geo?.country_code,
    };

    let parentItem = formatItem;
    let parentItemGeoInfo = parentItem?.info?.geo;
    // 搜索时，
    //  zipcode展示label：zipcode,state,country
    //  非zipcode展示label：city,province,state,country
    while (associateTagsMap && parentItemGeoInfo?.type && parentItemGeoInfo?.type !== LocationGeoType.COUNTRY) {
      parentItem = associateTagsMap[parentItem?.parentId];
      parentItemGeoInfo = parentItem?.info?.geo;
      if (formatItem?.info?.geo?.type === LocationGeoType.ZIP_CODE) {
        if (parentItemGeoInfo?.type <= LocationGeoType.PROVINCE) {
          filterLabelList.push(parentItem.name);
        }
      } else {
        filterLabelList.push(parentItem.name);
      }
    }

    if (filterLabelList.length > 1) {
      formatItem.filterLabel = filterLabelList.join(', ');
    }

    return formatItem;
  }

  tags.forEach((item: LocationInfo) => {
    const formatItem = genFormatItem(item);
    formatResult.push(formatItem);
    formatResultMap[formatItem.id] = formatItem;

    if (!isNotNeedFormatAssociateTags) {
      let { parentId } = formatItem;
      while (parentId && !formatResultMap[parentId]) {
        const associateTag = associateTagsMap[parentId];
        const associateTagAfterFormat = genFormatItem(associateTag);
        formatResultMap[parentId] = associateTagAfterFormat;
        formatResult.push(associateTagAfterFormat);
        parentId = associateTagAfterFormat?.parentId;
      }
    }
  });

  return {
    formatResult,
    formatResultMap,
  };
}

export function getTtpCloverAreaInfo(originCountry: number[], currentCounry: number[] = []) {
  originCountry = originCountry || [];

  const isOriginHasCloverArea = originCountry.some(id => CloverAreaIds.includes(id));
  const isOriginHasTtpArea = originCountry.some(id => TtpAreaIds.includes(id));
  const isCurrentHasCloverArea = currentCounry.some(id => CloverAreaIds.includes(id));
  const isCurrentHasTtpArea = currentCounry.some(id => TtpAreaIds.includes(id));

  return {
    isOriginHasCloverArea,
    isOriginHasTtpArea,
    isCurrentHasCloverArea,
    isCurrentHasTtpArea,
  };
}
